import React, { useEffect, useState } from 'react';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import LoaderLayout from '@layouts/LoaderLayout';
import { getOperations } from '@selectors';

import PaymentSelect from './PaymentSelect';
import { withCustomProvider } from './context';
import AccountsBuyExchange from './operations/AccountsBuyExchange';
import AccountsBuyInvoice from './operations/AccountsBuyInvoice';
import AccountsSellExchange from './operations/AccountsSellExchange';
import Buy from './operations/Buy';
import BuyWithNewCard from './operations/BuyWithNewCard';
import Deposit from './operations/Deposit';
import Sell from './operations/Sell';
import SellWithNewCard from './operations/SellWithNewCard';
import Withdraw from './operations/Withdraw';

import style from './OperationBlock.scss';

const cn = bemCssModules(style, 'OperationBlock');
const ti = getTestId('OperationBlock');

const Content = withCustomProvider<{ className: string }>(({ className }) => {
  const [store] = useStore();
  const operations = getOperations(store);

  const getContent = () => {
    if (operations.deposit) return <Deposit />;
    if (operations.withdraw) return <Withdraw />;
    if (operations.sell_with_new_card) return <SellWithNewCard />;
    if (operations.sell) return <Sell />;
    if (operations.accounts_buy_exchange) return <AccountsBuyExchange />;
    if (operations.accounts_sell_exchange) return <AccountsSellExchange />;
    if (operations.accounts_buy_invoice) return <AccountsBuyInvoice />;
    if (operations.buy_with_new_card) return <BuyWithNewCard />;
    return <Buy />;
  };

  return (
    <div className={className} data-testid={ti()}>
      <PaymentSelect className={cn('payment-select')} />
      {getContent()}
    </div>
  );
});

export const OperationBlock: CustomFC = ({ className }) => {
  const [initLoading, setInitLoading] = useState(true);
  const [{ wallet, global, cards }] = useStore();

  useEffect(() => {
    setInitLoading(false);
  }, []);

  const isLoading =
    initLoading ||
    (initLoading && wallet.loaders.getWallet) ||
    global.loaders.getCurrencies ||
    cards.loaders.getCards !== false;

  return (
    <LoaderLayout isLoading={isLoading} height="341px">
      <Content className={cn(null, [className])} />
    </LoaderLayout>
  );
};

export default OperationBlock;
